import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { clone } from 'lodash-es';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Renderer, { getData, } from '../Renderer';
import BackgroundImage from './BackgroundImage';
import PlaceHolder from '../../portal/common/PlaceHolder';
const OutputItems = ({ items, indexOffset, canAdd, editData, configId, context, data, }) => (_jsx(_Fragment, { children: items.map((itemId, index) => {
        // its done this way to get the key in the right place...
        if (canAdd) {
            return (_jsxs(React.Fragment, { children: [_jsx(editData.DropTarget, { dropId: `${configId}@${index + indexOffset}`, editData: editData }), _jsx(Renderer, { configId: itemId, data: data, context: context, editData: editData })] }, itemId));
        }
        return (_jsx(Renderer, { configId: itemId, data: data, context: context, editData: editData }, itemId));
    }) }));
const FullPageLayout = ({ items, spacing, limitToPageWidth, backgroundImage, data, context, editData, configId, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
config, }) => {
    const canAdd = editData && editData.actions && editData.actions.canEdit(configId);
    const isEmpty = () => (items.length === 0 && editData);
    const headerItems = [items.slice(0, 1)];
    const footerItems = (items.length > 1) ? [items.slice(-1)] : [];
    const contentItems = (items.length > 2) ? [items.slice(1, -1)] : [];
    return (_jsx(BackgroundImage, { backgroundImage: backgroundImage, children: _jsxs(Stack, { direction: "column", spacing: spacing, sx: {
                flexDirection: 'column',
                display: 'flex',
                height: '100%',
                ...(limitToPageWidth && {
                    maxWidth: 1200,
                    marginX: 'auto',
                    width: '100%',
                }),
            }, children: [_jsx(Box, { children: _jsx(OutputItems, { items: headerItems, indexOffset: 0, canAdd: canAdd, editData: editData, configId: configId, context: context, data: data }) }), _jsx(Box, { sx: {
                        flexGrow: 1,
                        overflowY: 'auto',
                    }, children: _jsx(OutputItems, { items: contentItems, indexOffset: 1, canAdd: canAdd, editData: editData, configId: configId, context: context, data: data }) }), _jsx(Box, { sx: {}, children: _jsx(OutputItems, { items: footerItems, indexOffset: items.length - 1, canAdd: canAdd, editData: editData, configId: configId, context: context, data: data }) }), canAdd && _jsx(editData.DropTarget, { dropId: `${configId}@${items.length}`, editData: editData }), isEmpty() && (_jsx(PlaceHolder, { placeHolderName: "Configure Row Layout" }))] }) }));
};
FullPageLayout.getData = ({ items, backgroundImage, data, context, editData, }, store) => (Promise.allSettled([
    BackgroundImage.getData({ backgroundImage, context }, store),
    ...items.map((itemId) => (getData({
        configId: itemId,
        data,
        context,
        editData,
    }, store))),
]));
const meta = {
    group: 'hidden',
    name: 'Full Page Layout',
    description: 'Displays a stack of one or more components stacked vertically.  First item is fixed to top of page, last item is fixed to bottom of page.',
    props: [
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
        },
        {
            key: 'spacing',
            name: 'Spacing',
            type: 'number',
            min: -20,
            max: 20,
            description: 'Amount of space between items in the stack.',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
        {
            key: 'backgroundImage',
            name: 'Background Image',
            type: 'backgroundImage',
            description: 'Add a background image to the stack.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'RowLayout',
        editProps: {
            canAdd: true,
            canRemove: true,
        },
        props: {
            items: [],
            backgroundColor: '#00ff00',
            limitToPageWidth: true,
            verticalPadding: 1,
            horizontalPadding: 1,
        },
    },
    getChildren: (config) => (config.props.items),
    actions: (componentConfig, addComponentDialog) => ([
        ['Add Item', () => {
                console.log('Handle add item');
                // @todo - this should be handled at a higher level and/or in the list widget itself.
                const addHandler = ((key) => {
                    // @ts-expect-error - need to update this code
                    const addComponent = components[key];
                    componentConfig.props.items = [
                        ...componentConfig.props.items,
                        clone(addComponent.meta.defaultConfig),
                    ];
                });
                addComponentDialog(addHandler);
            }],
    ]),
};
FullPageLayout.meta = meta;
export default FullPageLayout;
//# sourceMappingURL=FullPageLayout.js.map